var t = ":host,:root{--ngc-alert-padding: 1.5rem;--ngc-alert-font-size: 1.0625rem}";
export { t as default };